module.exports = __webpack_public_path__ + "background.31a53144.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/components/HomePage/Header/images/background.jpg
// module id = 623
// module chunks = 0